"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Icons = require("./../Icons");

require("./DropDown.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var instances = 0;

var _default = function _default(_ref) {
  var _ref$buttonAriaLabelC = _ref.buttonAriaLabelClosed,
      buttonAriaLabelClosed = _ref$buttonAriaLabelC === void 0 ? 'Open selection menu' : _ref$buttonAriaLabelC,
      _ref$buttonAriaLabelO = _ref.buttonAriaLabelOpen,
      buttonAriaLabelOpen = _ref$buttonAriaLabelO === void 0 ? 'Close selection menu' : _ref$buttonAriaLabelO,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$defaultColumns = _ref.defaultColumns,
      defaultColumns = _ref$defaultColumns === void 0 ? [] : _ref$defaultColumns,
      _ref$itemSelectionLeg = _ref.itemSelectionLegend,
      itemSelectionLegend = _ref$itemSelectionLeg === void 0 ? 'Select items' : _ref$itemSelectionLeg,
      _ref$selectAllAriaLab = _ref.selectAllAriaLabel,
      selectAllAriaLabel = _ref$selectAllAriaLab === void 0 ? 'Select all items' : _ref$selectAllAriaLab,
      _ref$resetToDefaultAr = _ref.resetToDefaultAriaLabel,
      resetToDefaultAriaLabel = _ref$resetToDefaultAr === void 0 ? 'Reset to default selection' : _ref$resetToDefaultAr,
      children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'right' : _ref$align,
      onChange = _ref.onChange,
      onMultipleChange = _ref.onMultipleChange,
      itemToString = _ref.itemToString;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(new Map()),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedItemsMap = _useState4[0],
      setSelectedItemsMap = _useState4[1];

  var _useState5 = (0, _react.useState)(new Map()),
      _useState6 = _slicedToArray(_useState5, 2),
      defaultColumnsMap = _useState6[0],
      setDefaultColumnsMap = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      instanceNum = _useState8[0],
      setInstanceNum = _useState8[1];

  var renderRef = (0, _react.useRef)();
  var buttonRef = (0, _react.useRef)();
  var panelRef = (0, _react.useRef)();
  var itemsRef = (0, _react.useRef)([]);

  var toggle = function toggle(item) {
    if (selectedItemsMap.get(item.field)) {
      // set to null instead of using .delete() because .delete() returns bool
      setSelectedItemsMap(new Map(selectedItemsMap.set(item.field, null)));
    } else {
      setSelectedItemsMap(new Map(selectedItemsMap.set(item.field, item)));
    }

    if (onChange) {
      onChange(item);
    }
  };

  var selectAll = function selectAll() {
    setSelectedItemsMap(items.reduce(function (map, item) {
      map.set(item.field, item);
      return map;
    }, new Map()));

    if (onMultipleChange) {
      var toggled = items.filter(function (item) {
        return !item.show;
      }).reduce(function (obj, item) {
        return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, item.field, true));
      }, {});
      onMultipleChange(toggled);
    }
  };

  var resetToDefaults = function resetToDefaults() {
    setSelectedItemsMap(new Map(defaultColumnsMap));

    if (onMultipleChange) {
      var toggled = items.filter(function (item) {
        return item.show && !defaultColumnsMap.has(item.field) || !item.show && defaultColumnsMap.has(item.field);
      });
      var changes = toggled.reduce(function (obj, item) {
        return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, item.field, !item.show));
      }, {});
      onMultipleChange(changes);
    }
  };

  var focusNext = function focusNext(i) {
    itemsRef.current[(i + 1) % items.length].focus();
  };

  var focusPrev = function focusPrev(i) {
    itemsRef.current[(i - 1 + items.length) % items.length].focus();
  };

  var focusFirst = function focusFirst() {
    itemsRef.current[0].focus();
  };

  var focusLast = function focusLast() {
    itemsRef.current[items.length - 1].focus();
  };

  var handleKeyPress = function handleKeyPress(e, i) {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        focusNext(i);
        break;

      case 'ArrowUp':
        e.preventDefault();
        focusPrev(i);
        break;

      case 'Home':
        e.preventDefault();
        focusFirst();
        break;

      case 'End':
        e.preventDefault();
        focusLast();
        break;

      default:
        break;
    }
  };

  var handleEsc = function handleEsc(e) {
    if (isOpen && e.key === 'Escape') {
      setIsOpen(false);
      buttonRef.current.focus();
    }
  };

  var handleBlur = function handleBlur(e) {
    var nextTarget = e.relatedTarget;

    if (isOpen && panelRef.current && !panelRef.current.contains(nextTarget)) {
      setIsOpen(false);
    }
  };

  var handleClickOutside = function handleClickOutside(e) {
    if (isOpen && panelRef.current && !panelRef.current.contains(e.target) && e.target !== buttonRef.current) {
      setIsOpen(false);
    }
  }; // set defaults and selected items on initial load


  (0, _react.useEffect)(function () {
    if (renderRef && !renderRef.current) {
      setDefaultColumnsMap(defaultColumns.filter(function (column) {
        return column.field !== 'name';
      }).reduce(function (map, item) {
        map.set(item.field, item);
        return map;
      }, new Map()));
      setSelectedItemsMap(items.filter(function (item) {
        return item.show;
      }).reduce(function (map, item) {
        map.set(item.field, item);
        return map;
      }, new Map()));
      itemsRef.current = new Array(items.length);
      renderRef.current = true;
    }
  }, [renderRef]); // use instance number to ensure IDs stay unique for multiple dropdowns on a page

  (0, _react.useEffect)(function () {
    instances += 1;
    setInstanceNum(instances);
    return function () {
      instances -= 1;
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (isOpen) {
      window.addEventListener('click', handleClickOutside);
      window.addEventListener('keydown', handleEsc);
      focusFirst();
    }

    return function () {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropDownHeader"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    "aria-label": isOpen ? buttonAriaLabelOpen : buttonAriaLabelClosed,
    "aria-haspopup": "true",
    "aria-expanded": isOpen,
    onBlur: handleBlur,
    onClick: function onClick(e) {
      e.preventDefault();
      setIsOpen(function (isOpen) {
        return !isOpen;
      });
    },
    ref: buttonRef,
    className: "dropDownButton"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropDownButtonContent"
  }, children), /*#__PURE__*/_react["default"].createElement(_Icons.ArrowIcon, {
    isOpen: isOpen
  })), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropDownContent multiSelectDropDown",
    style: {
      right: align === 'right' ? 0 : 'auto',
      left: align === 'right' ? 'auto' : 0
    },
    ref: panelRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "multiSelectDropDownWrapper"
  }, /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: "multiSelectDropDownFieldSet"
  }, /*#__PURE__*/_react["default"].createElement("legend", {
    style: {
      position: 'absolute',
      clip: 'rect(0 0 0 0)'
    }
  }, itemSelectionLegend), /*#__PURE__*/_react["default"].createElement("div", {
    className: "multiSelectDropDownControls"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick(e) {
      e.preventDefault();
      selectAll();
    },
    className: "multiSelectDropDownControlsButton",
    "aria-label": selectAllAriaLabel
  }, /*#__PURE__*/_react["default"].createElement(_Icons.CheckIcon, null), "Select All"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick(e) {
      e.preventDefault();
      resetToDefaults();
    },
    className: "multiSelectDropDownControlsButton",
    "aria-label": resetToDefaultAriaLabel
  }, /*#__PURE__*/_react["default"].createElement(_Icons.ResetIcon, null), "Reset to Defaults")), items && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "multiSelectDropDownList"
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "multiselect-dropdown-".concat(instanceNum, "-item-").concat(index)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "dropDownContentElement multiSelectDropDownElement"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "multiselect-dropdown-".concat(instanceNum, "-item-").concat(index),
      className: "multiSelectDropDownElementLabel"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      ref: function ref(el) {
        return itemsRef.current[index] = el;
      },
      checked: !!selectedItemsMap.get(item.field),
      onChange: function onChange() {
        return toggle(item);
      },
      name: "multiselect-dropdown-".concat(instanceNum, "-item-").concat(index),
      type: "checkbox",
      id: "multiselect-dropdown-".concat(instanceNum, "-item-").concat(index),
      onKeyDown: function onKeyDown(e) {
        return handleKeyPress(e, index);
      },
      className: "multiSelectDropDownElementInput",
      onBlur: index === items.length - 1 ? handleBlur : undefined
    }), itemToString(item))));
  }))))));
};

exports["default"] = _default;